import { EntityModel } from '@/interfaces'
import {
  ALL_CALCULATION_SETTINGS_QUERY,
  CREATE_CALCULATION_SETTINGS_MUTATION,
  DELETE_CALCULATION_SETTINGS_MUTATION,
  FORCE_DELETE_CALCULATION_SETTINGS_MUTATION,
  SINGLE_CALCULATION_SETTINGS_QUERY,
  UPDATE_CALCULATION_SETTINGS_MUTATION,
} from './graphql'

const travelPricingServiceCalculationSettingsModel: EntityModel = {
  name: 'calculationSettings',
  namePlural: 'calculationSettings',
  uniqueName: 'travelPricingServiceCalculationSettings',
  uniqueNamePlural: 'travelPricingServiceCalculationSettings',
  path: 'travel/pricing/calculation_settings',
  baseUrl: '/travel/pricing/calculation_settings',
  translationPrefix: 'entities:travelPricingServiceCalculationSettings.',
  getDisplayName: (values: any) => {
    return 'Calculation Settings'
  },
  gql: {
    getAll: ALL_CALCULATION_SETTINGS_QUERY,
    getSingle: SINGLE_CALCULATION_SETTINGS_QUERY,
    create: CREATE_CALCULATION_SETTINGS_MUTATION,
    update: UPDATE_CALCULATION_SETTINGS_MUTATION,
    delete: DELETE_CALCULATION_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_CALCULATION_SETTINGS_MUTATION,
  },
  attributes: {
    type: {
      name: 'type',
      label: 'entities:travelPricingServiceCalculationSettings.attributes.type.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:travelPricingServiceCalculationSettings.attributes.type.selectOptions.once.label',
          value: 'once',
        },
        {
          label: 'entities:travelPricingServiceCalculationSettings.attributes.type.selectOptions.nights.label',
          value: 'nights',
        },
        {
          label: 'entities:travelPricingServiceCalculationSettings.attributes.type.selectOptions.days.label',
          value: 'days',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    considerHotelNights: {
      name: 'considerHotelNights',
      label: 'entities:travelPricingServiceCalculationSettings.attributes.considerHotelNights.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPricingServiceCalculationSettingsModel
